import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownProps {
  /** Seconds remaining when the page loads. */
  initialSeconds: number;
  size?: 'md' | 'lg';
}
const units = ['Godz', 'Min', 'Sek'] as const;
export function Countdown({
  initialSeconds,
  size = 'md'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(initialSeconds);
  const values = [hours, minutes, seconds];
  return <div className="flex items-start gap-2.5 sm:gap-3" role="timer" aria-live="off" data-id="element-79" data-mp="3c131949yu1l7">
      {values.map((value, index) => <React.Fragment key={units[index]} data-id="element-80" data-mp="3h2aal7rrb8tz" data-mpi={index}>
          {index > 0 && <span className={`font-display leading-none text-amber ${size === 'lg' ? 'mt-3 text-3xl sm:text-5xl' : 'mt-2.5 text-2xl sm:text-4xl'}`} aria-hidden="true" data-id="element-81" data-mp="32500a1quo8zu">
              :
            </span>}
          <div className="flex flex-col items-center" data-id="element-82" data-mp="15bocvt6ntsd5">
            <span className={`flex items-center justify-center rounded-lg border border-night-600 bg-night-800 font-display tabular-nums leading-none text-cream ${size === 'lg' ? 'h-16 w-16 text-4xl sm:h-24 sm:w-24 sm:text-6xl' : 'h-14 w-14 text-3xl sm:h-20 sm:w-20 sm:text-5xl'}`} data-id="element-83" data-mp="1592821b5lqym">
              {value}
            </span>
            <span className="mt-2 text-[10px] font-semibold uppercase tracking-label text-cream-muted" data-id="element-84" data-mp="f22ca2efwdzk">
              {units[index]}
            </span>
          </div>
        </React.Fragment>)}
    </div>;
}